/* eslint-disable react/jsx-props-no-spreading */
import { ReactComponent as Alert } from "../assets/icons/Alert.svg";
import { ReactComponent as ArrowDownIcon } from "../assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowRightIcon } from "../assets/icons/ArrowRight.svg";
import { ReactComponent as ArrowUpIcon } from "../assets/icons/ArrowUp.svg";
import { ReactComponent as CalendarIcon } from "../assets/icons/Calendar.svg";
import { ReactComponent as ChartBarSolidIcon } from "../assets/icons/ChartBarSolid.svg";
import { ReactComponent as CheckIcon } from "../assets/icons/Check.svg";
import { ReactComponent as CircleXMarkIcon } from "../assets/icons/CircleXMark.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/Close.svg";
import { ReactComponent as CogIcon } from "../assets/icons/Cog.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/Delete.svg";
import { ReactComponent as DoneIcon } from "../assets/icons/DoneRegular.svg";
import { ReactComponent as EditIcon } from "../assets/icons/EditIcon.svg";
import { ReactComponent as ExpandLessRegularIcon } from "../assets/icons/ExpandLessRegular.svg";
import { ReactComponent as ExpandMoreRegularIcon } from "../assets/icons/ExpandMoreRegular.svg";
import { ReactComponent as FolderIcon } from "../assets/icons/Folder.svg";
import { ReactComponent as InformationIcon } from "../assets/icons/Information.svg";
import { ReactComponent as InformationModalIcon } from "../assets/icons/InformationModal.svg";
import { ReactComponent as WarningModalIcon } from "../assets/icons/WarningModal.svg";
import { ReactComponent as WarningHighLight } from "../assets/icons/WarningHighLight.svg";
import { ReactComponent as LeftArrowIcon } from "../assets/icons/LeftArrow.svg";
import { ReactComponent as LessIcon } from "../assets/icons/Less.svg";
import { ReactComponent as HistoryFileIcon } from "../assets/icons/ListFile.svg";
import { ReactComponent as MenuHamburguerIcon } from "../assets/icons/MenuHamburg.svg";
import { ReactComponent as PenToSquareRegularIcon } from "../assets/icons/PenToSquareRegular.svg";
import { ReactComponent as PlanIcon } from "../assets/icons/PlanIcon.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/Plus.svg";
import { ReactComponent as ReplyIcon } from "../assets/icons/ReplyIcon.svg";
import { ReactComponent as RightArrowIcon } from "../assets/icons/RightArrow.svg";
import { ReactComponent as RightArrowOutlineIcon } from "../assets/icons/RightArrowOutline.svg";
import { ReactComponent as ScheduleIcon } from "../assets/icons/Schedule.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/Search.svg";
import { ReactComponent as SelectArrowDownIcon } from "../assets/icons/SelectArrowDow.svg";
import { ReactComponent as SelectArrowUpIcon } from "../assets/icons/SelectArrowUp.svg";
import { ReactComponent as SuccessModalIcon } from "../assets/icons/SuccessModal.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/UploadIcon.svg";
import { ReactComponent as UserIcon } from "../assets/icons/User.svg";
import { ReactComponent as ViewIcon } from "../assets/icons/View.svg";
import { ReactComponent as WorkflowIcon } from "../assets/icons/Workflow.svg";
import { ReactComponent as LogoutIcon } from "../assets/icons/Logout.svg";
import { ReactComponent as IconEdit } from "../assets/icons/Edit.svg";
import { ReactComponent as IconDelete } from "../assets/icons/DeleteIcon.svg";
import { ReactComponent as AddIcon } from "../assets/icons/AddIcon.svg";
import { ReactComponent as ReportIcon } from "../assets/icons/ReportIcon.svg";
import { ReactComponent as PrintReportIcon } from "../assets/icons/PrintReportIcon.svg";
import { ReactComponent as DIcon } from "../assets/icons/DIcon.svg";
import { ReactComponent as IDIcon } from "../assets/icons/IDIcon.svg";
import { ReactComponent as ABIcon } from "../assets/icons/ABIcon.svg";
import { ReactComponent as CalendarCheckIcon } from "../assets/icons/CalendarCheck.svg";
import { ReactComponent as CIcon } from "../assets/icons/CIcon.svg";
import { ReactComponent as CrossCircleIcon } from "../assets/icons/CrossCircle.svg";
import { ReactComponent as NegativeCircleIcon } from "../assets/icons/NegativeCircle.svg";
import { ReactComponent as WarningCircleIcon } from "../assets/icons/WarningCircle.svg";
import { ReactComponent as CheckinIcon } from "../assets/icons/CheckinIcon.svg";
import { ReactComponent as AlertStatus } from "../assets/icons/AlertStatus.svg";
import { ReactComponent as IconCalendar } from "../assets/icons/CalendarIcon.svg";
import { ReactComponent as PlusIconNoBorder } from "../assets/icons/PlusIcon.svg";
import { ReactComponent as AngleDownIcon } from "../assets/icons/AngleDown.svg";
import { ReactComponent as UploadArrow } from "../assets/icons/UploadArrow.svg";
import { ReactComponent as AusenciaIcon } from "../assets/icons/AusenciaIcon.svg";
import { ReactComponent as ShieldIcon } from "../assets/icons/shield-keyhole-regular.svg";

type IconProps = React.SVGProps<SVGSVGElement>;

const ChartSimpleRegular = (color: string, props: IconProps) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.625 0.25C10.6602 0.25 11.5 1.08945 11.5 2.125V15.875C11.5 16.9102 10.6602 17.75 9.625 17.75H8.375C7.33984 17.75 6.5 16.9102 6.5 15.875V2.125C6.5 1.08945 7.33984 0.25 8.375 0.25H9.625ZM9.625 2.125H8.375V15.875H9.625V2.125ZM3.375 7.75C4.41016 7.75 5.25 8.58984 5.25 9.625V15.875C5.25 16.9102 4.41016 17.75 3.375 17.75H2.125C1.08945 17.75 0.25 16.9102 0.25 15.875V9.625C0.25 8.58984 1.08945 7.75 2.125 7.75H3.375ZM3.375 9.625H2.125V15.875H3.375V9.625ZM12.75 4.625C12.75 3.58984 13.5898 2.75 14.625 2.75H15.875C16.9102 2.75 17.75 3.58984 17.75 4.625V15.875C17.75 16.9102 16.9102 17.75 15.875 17.75H14.625C13.5898 17.75 12.75 16.9102 12.75 15.875V4.625ZM14.625 15.875H15.875V4.625H14.625V15.875Z"
            fill={color}
        />
    </svg>
);

export {
    Alert,
    ArrowDownIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    CalendarIcon,
    ChartBarSolidIcon,
    CheckIcon,
    CircleXMarkIcon,
    CloseIcon,
    CogIcon,
    DeleteIcon,
    DoneIcon,
    EditIcon,
    ExpandLessRegularIcon,
    ExpandMoreRegularIcon,
    FolderIcon,
    InformationIcon,
    InformationModalIcon,
    WarningModalIcon,
    WarningHighLight,
    LeftArrowIcon,
    LessIcon,
    HistoryFileIcon,
    MenuHamburguerIcon,
    PenToSquareRegularIcon,
    PlanIcon,
    PlusIcon,
    ReplyIcon,
    RightArrowIcon,
    RightArrowOutlineIcon,
    ScheduleIcon,
    SearchIcon,
    SuccessModalIcon,
    UploadIcon,
    UserIcon,
    WorkflowIcon,
    ViewIcon,
    SelectArrowDownIcon,
    SelectArrowUpIcon,
    LogoutIcon,
    IconEdit,
    IconDelete,
    AddIcon,
    ReportIcon,
    PrintReportIcon,
    DIcon,
    IDIcon,
    ABIcon,
    CalendarCheckIcon,
    CIcon,
    CrossCircleIcon,
    NegativeCircleIcon,
    WarningCircleIcon,
    CheckinIcon,
    AlertStatus,
    IconCalendar,
    PlusIconNoBorder,
    AngleDownIcon,
    UploadArrow,
    AusenciaIcon,
    ShieldIcon,
    ChartSimpleRegular,
};
